module.exports = __webpack_public_path__ + "static/img/6.173bc6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/6.png
// module id = GAik
// module chunks = 0